import { TipRepository } from "../../../repositories/tipRepository"
import { UseCase } from "../../useCase"
import { AddCountryTipRequest } from "./request"
import { AddCountryTipResponse } from "./response"

export class AddCountryTipUseCase implements UseCase<AddCountryTipRequest, AddCountryTipResponse> {
	private _repository

	constructor({ TipRepository }: { TipRepository: TipRepository }) {
		this._repository = TipRepository
	}

	exec({ tipId, countryId, position }: AddCountryTipRequest) {
		return this._repository.addCountryTip(tipId, countryId, position)
	}
}
